export default __webpack_public_path__ + "static/media/action.3cda0784.svg";